import { Button } from '@/components/ui/button'
import { FeaturedGameExcerpt } from '@/components/featured-game-excerpt'
import { GameSection } from '@/components/game-section'
import { PromoVideoFrame } from '@/components/promo-video-frame'
import { useArenaSeoHead } from '@/lib/arena-seo-head'
import { gameStartButtonClassName } from '@/lib/game-start-button-style'
import { useI18n } from '@/lib/i18n'
import { Link } from 'react-router-dom'

const heroColumnsClassName = 'lg:grid lg:max-w-6xl lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:items-center lg:gap-14'

export function GameHomepagePage() {
  const { language, t, isLoading } = useI18n()
  useArenaSeoHead('home', !isLoading)

  return (
    <main className="grid grid-cols-[minmax(0,1fr)] pt-16" data-village-page="home">
      <section
        id="hero"
        data-testid="game-homepage"
        className="relative isolate flex min-h-[calc(100svh-4rem)] items-center overflow-hidden bg-[#071322] bg-[url('/images/game-homepage-mobile.png')] bg-cover bg-center text-[#fff8e8] md:bg-[url('/images/game-homepage-desktop.png')] lg:col-start-1 lg:row-start-1"
      >
        <div className="w-full translate-y-[8svh] px-6 sm:px-8 md:translate-y-0 md:py-24">
          <div className={`mx-auto max-w-4xl ${heroColumnsClassName}`}>
            <div
              dir={language === 'ar' ? 'rtl' : 'ltr'}
              className="max-w-[min(100%,42rem)] text-center md:text-start"
            >
              <h1 className="mx-auto max-w-[17ch] text-[clamp(1.9rem,7.5vw,3.75rem)] font-semibold leading-[1.13] -tracking-wide [text-wrap:balance] md:mx-0">
                {isLoading ? null : t('gameHomepage.headline')}
              </h1>
              <Button
                asChild
                className={`${gameStartButtonClassName} mt-9 max-w-64 focus-visible:ring-4 focus-visible:ring-amber-100`}
              >
                <Link to="/new" data-testid="game-homepage-start">
                  <span className="relative z-10 font-bold">
                    {isLoading ? null : t('game.startGame')}
                  </span>
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
      <section
        data-testid="game-homepage-video-section"
        className="border-b border-[#a88a5d]/25 bg-[#071322] px-6 py-16 sm:px-8 lg:pointer-events-none lg:relative lg:z-10 lg:col-start-1 lg:row-start-1 lg:self-center lg:border-0 lg:bg-transparent lg:py-24"
      >
        <div className={`mx-auto max-w-4xl ${heroColumnsClassName}`}>
          <PromoVideoFrame
            language={language}
            testId="game-homepage-video"
            className="border border-[#a88a5d]/60 bg-[#102131] shadow-[0_18px_48px_rgba(0,0,0,0.35)] lg:pointer-events-auto lg:col-start-2"
          />
        </div>
      </section>
      <FeaturedGameExcerpt />
      <section id="game-launcher" className="scroll-mt-20">
        <GameSection headingLevel={2} />
      </section>
    </main>
  )
}
